import React, { useEffect, useState } from 'react';
import { Highlight, themes } from 'prism-react-renderer';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { scripts, tabInfoCredit } from '../showCase.constants';
import '../trade-in/tradeIn.scss';

const CustomTabPanel: React.FC<{
  value: number;
  index: number;
  children: React.ReactNode;
}> = ({ value, index, children }) => {
  return value === index ? <div>{children}</div> : null;
};

const CreditScore: React.FC = () => {
  const [copied, setCopied] = useState<string | number | null>(null);
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleCopy = async (scriptKey: string | number) => {
    let script = '';
    if (scriptKey === 'setupScript') {
      script = scripts.setupScript;
    } else if (typeof scriptKey === 'number') {
      script = tabInfoCredit[scriptKey]?.code || '';
    }

    await navigator.clipboard.writeText(script);
    setCopied(scriptKey);
    sessionStorage.setItem('copiedScript', scriptKey.toString());
  };

  useEffect(() => {
    const handleBeforeUnload = () => sessionStorage.removeItem('copiedScript');
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  return (
    <div className='trade-in-container'>
      <h1>Dabadu</h1>
      <p className='info'>How to Install the Dabadu Widget on your website</p>

      <hr />

      {/* Step 1 */}
      <div className='steps-div'>
        <p className='main-step'>
          Step 1: Install global <code>&lt;script&gt;</code> tag
        </p>
        <p className='info'>Copy this setup script, and paste it into the HTML of your site.</p>
        <p className='info'>
          This is commonly placed inside of the <code>&lt;head&gt;</code> element.
        </p>

        <div className='code-editor'>
          <button onClick={() => handleCopy('setupScript')}>{copied === 'setupScript' ? 'Copied!' : 'Copy'}</button>
          <Highlight theme={themes.vsLight} code={scripts.setupScript.trim()} language='javascript'>
            {({ className, style, tokens, getLineProps, getTokenProps }) => (
              <pre className={className} style={style}>
                {tokens.map((line, i) => (
                  <div {...getLineProps({ line, key: i })}>
                    {line.map((token, key) => (
                      <span {...getTokenProps({ token, key })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
        </div>
        <p className='note'>** If you already have this installed on the page, you can skip this step</p>
      </div>

      {/* Step 2 */}
      <div className='second-steps-div'>
        <p className='main-step'>Step 2: Install CTAs</p>
        <p className='info'>Select a CTA type:</p>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label='dynamic tabs example'>
            {tabInfoCredit.map((tab, index) => (
              <Tab key={index} label={tab.label} />
            ))}
          </Tabs>
        </Box>

        {tabInfoCredit.map((tab, index) => (
          <CustomTabPanel key={index} value={value} index={index}>
            {tab.code && (
              <>
                <p className='info code-label'>Code</p>
                <p className='info'>{tab?.description || ''}</p>

                <div className='code-editor'>
                  <button onClick={() => handleCopy(index)}>{copied === index ? 'Copied!' : 'Copy'}</button>
                  <Highlight theme={themes.vsLight} code={tab.code.trim()} language='javascript'>
                    {({ className, style, tokens, getLineProps, getTokenProps }) => (
                      <pre className={className} style={style}>
                        {tokens.map((line, i) => (
                          <div {...getLineProps({ line, key: i })}>
                            {line.map((token, key) => (
                              <span {...getTokenProps({ token, key })} />
                            ))}
                          </div>
                        ))}
                      </pre>
                    )}
                  </Highlight>
                </div>
              </>
            )}

            {/* Preview */}
            <div className='preview-container'>
              <p>Preview</p>
              <div className='code-editor'>
                {/* {tab.image ? (
									<img src={tab.image} alt={`${tab.label} preview`} />
								) : (
									<p>No preview available</p>
								)} */}

                {tab.image?.map((img, index) => (
                  <>
                    <img key={index} src={img} alt={`${tab.label} preview`} />
                    <br />
                    <br />
                    <br />
                  </>
                ))}
              </div>
            </div>
          </CustomTabPanel>
        ))}
      </div>
    </div>
  );
};

export default CreditScore;
